var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "26px",
    viewBox: "0 0 31 26",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-640.000000, -279.000000)",
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(271.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(111.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(197.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.800000, 0.450000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Communication-/-mail_outline",
    transform: "translate(57.750000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 35.7 0 35.7 36.75 0 36.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75,6.125 L5.95,6.125 C4.31375,6.125 2.989875,7.503125 2.989875,9.1875 L2.975,27.5625 C2.975,29.246875 4.31375,30.625 5.95,30.625 L29.75,30.625 C31.38625,30.625 32.725,29.246875 32.725,27.5625 L32.725,9.1875 C32.725,7.503125 31.38625,6.125 29.75,6.125 Z M29.75,27.5625 L5.95,27.5625 L5.95,12.25 L17.85,19.90625 L29.75,12.25 L29.75,27.5625 Z M17.85,16.84375 L5.95,9.1875 L29.75,9.1875 L17.85,16.84375 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.aef27825.svg";
export { ForwardRef as ReactComponent };